import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export const useDeleteStateReference = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (id: string) => {
			try {
				const { data } = await api.delete(`/state-reference/delete/${id}`);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao excluir referência');
			}
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['state-references'] }),
		onError: error =>
			console.error('Erro ao excluir referência:', getApiErrorMessage(error, 'Erro ao excluir referência')),
	});
};
